import { Form } from "@circle-react-shared/uikit/Form";
import type { Editor } from "@tiptap/core";
import type { ReactNode } from "react";

import { PaywallFormFields } from "./PaywallFormFields";
import { usePaywallSettingsData } from "./usePaywallSettingsData";
import { validationSchema } from "./validationSchema";

interface PaywallSettingsContentProps {
  children?: ReactNode;
  editor: Editor;
  formId?: string;
  onClose: () => void;
  range: { from: number; to: number };
}

export const PaywallSettingsContent = ({
  children,
  editor,
  formId,
  onClose,
  range,
}: PaywallSettingsContentProps) => {
  const data = usePaywallSettingsData(editor);
  if (!data) return null;

  return (
    <Form
      id={formId}
      defaultValues={data.defaultValues}
      onSubmit={attrs => {
        editor.commands.setPaywall({ range, attrs, isEdit: data.isEdit });
        onClose();
      }}
      validationSchema={validationSchema}
      shouldStopPropagation
      noValidate
    >
      <PaywallFormFields
        paywalls={data.paywalls}
        isLoading={data.isPending}
        isError={data.isError}
      />
      {children}
    </Form>
  );
};
